import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
const NavBar = () => {
	return (
		<nav className="navbar fixed overflow-hidden w-full top-0 z-10">
			<Disclosure
				as="nav"
				className="bg-slate-900 saturate-200 border-b-2 px-2 border-slate-700"
			>
				{({ open }) => (
					<>
						<div className="max-w-2xl mx-auto sm:px-4 xl:px-0">
							<div className="relative flex items-center justify-between h-16">
								<div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
									{/* Mobile menu button*/}
									<Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-slate-100 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
										<span className="sr-only">Open main menu</span>
										{open ? (
											/* XIcon */
											<svg
												className="block h-6 w-6"
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke="currentColor"
												aria-hidden="true"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth="2"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										) : (
											/* HamburguerIcon */
											<svg
												className="block h-6 w-6"
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke="currentColor"
												aria-hidden="true"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth="2"
													d="M4 6h16M4 12h16M4 18h16"
												/>
											</svg>
										)}
									</Disclosure.Button>
								</div>
								<div className="flex-1 flex items-center justify-center sm:items-center sm:justify-start">
									<div className="flex-shrink-0 flex items-center">
										<NavLink to="/">
											<img
												className="h-12 w-auto rounded-md saturate-200 brightness-200 contrast-200"
												src="/amentibus-cultui.jpeg"
												alt="logo"
											/>
										</NavLink>
									</div>
									<div className="hidden sm:block sm:ml-6">
										<div className="flex space-x-4">
											<NavLink
												to="/dashboard"
												className={({ isActive }) =>
													isActive
														? "bg-purple-900 text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
														: "text-purple-300 hover:bg-purple-700 hover:text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
												}
											>
												Dashboard
											</NavLink>
											<NavLink
												to="/players"
												className={({ isActive }) =>
													isActive
														? "bg-purple-900 text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
														: "text-purple-300 hover:bg-purple-700 hover:text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
												}
											>
												Players
											</NavLink>
											<NavLink
												to="/recruitment"
												className={({ isActive }) =>
													isActive
														? "bg-purple-900 text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
														: "text-purple-300 hover:bg-purple-700 hover:text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
												}
											>
												Recruitment
											</NavLink>
											<NavLink
												to="/comparator"
												className={({ isActive }) =>
													isActive
														? "bg-purple-900 text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
														: "text-purple-300 hover:bg-purple-700 hover:text-slate-100 px-3 py-2 rounded-md text-sm font-medium"
												}
											>
												Comparator
											</NavLink>
										</div>
									</div>
								</div>
							</div>
						</div>
						<Disclosure.Panel className="sm:hidden z-10 space-y-2 pb-2">
							<NavLink
								to="/dashboard"
								className="w-full bg-slate-900 hover:bg-slate-700 text-white block px-3 py-2 rounded-md text-base font-medium"
							>
								<Disclosure.Button className="w-full textLeft">
									Dashboard
								</Disclosure.Button>
							</NavLink>
							<NavLink
								to="/players"
								className="w-full bg-slate-900 hover:bg-slate-700 text-white block px-3 py-2 rounded-md text-base font-medium"
							>
								<Disclosure.Button className="w-full textLeft">
									Players
								</Disclosure.Button>
							</NavLink>
							<NavLink
								to="/recruitment"
								className="w-full bg-slate-900 hover:bg-slate-700 text-white block px-3 py-2 rounded-md text-base font-medium"
							>
								<Disclosure.Button className="w-full textLeft">
									Recruitment
								</Disclosure.Button>
							</NavLink>
						</Disclosure.Panel>
					</>
				)}
			</Disclosure>
		</nav>
	);
};

export default NavBar;
